import i18n from "i18next";
import { useState } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import { Color } from "../theme/Color";
import { FontSizes } from "../theme/FontSize";
import k from "./../i18n/keys";
import Button from "./Button/Button";
import Input from "./Form/Input";
import InputWrapper from "./Form/InputWrapper";
import Heading from "./Heading";
import Spacer from "./Spacer";
import { HTTP_METHOD, fetchAPI } from "../includes/fetch";

const Newsletter = () => {
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState(false);

  const subscribeNewsletter = async (event) => {
    event.preventDefault();

    const email = event.target.email.value;

    const res = await fetchAPI("/api/newsletter/subscribe", HTTP_METHOD.POST, {
      email,
    });

    if (res.ok) {
      setSubscribed(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <Col xs={12}>
      {subscribed ? (
        <Row center="xs">
          <Col style={{ color: Color.Green4 }}>
            {i18n.t(k.YOU_HAVE_BEEN_SUBSCRIBED)}
          </Col>
        </Row>
      ) : (
        <Row center="xs">
          <Col xs={12} style={{ maxWidth: "450px" }}>
            <Row center="xs">
              <Heading fontColor={Color.White}>Join our Newsletter</Heading>
            </Row>

            <form id="newsletter" onSubmit={subscribeNewsletter}>
              {error && (
                <Row center="xs">
                  <Col xs={12}>
                    <Row center="xs">
                      {i18n.t(k.PLEASE_ENTER_A_VALID_EMAIL_ADD)}
                    </Row>
                  </Col>
                </Row>
              )}

              <InputWrapper style={{ marginBottom: "0" }}>
                {!error && (
                  <Heading
                    fontColor={Color.White}
                    centered={true}
                    bold={false}
                    size={-1}
                  >
                    <Spacer bottom={0.5}>
                      Keep up-to-date with our latest news
                    </Spacer>
                  </Heading>
                )}
                <Input
                  autoComplete="off"
                  type="email"
                  data-cy="newsletter-email"
                  placeholder="Enter Your Email Address..."
                  name="email"
                  style={{ marginBottom: "0.2rem" }}
                ></Input>
              </InputWrapper>

              <Button
                color="secondary"
                label="Subscribe"
                data-cy="newsletter-subscribe"
              />
              <div
                style={{
                  textAlign: "center",
                  fontSize: FontSizes[-2],
                  color: "white",
                }}
              >
                We won't spam you or share your address.
              </div>
            </form>
          </Col>
        </Row>
      )}
    </Col>
  );
};
export default Newsletter;
